import React from 'react';
import { Button, TrevorIcon } from '@trevor/ui-components';
import { DASHBOARD_ADD_TEXT_BUTTON } from '@/constants/test-ids';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectIsWidgetConfigurationSidebarOpen } from '@/features/dashboard/dashboardSlice';
import { addTextBox } from '@/actions';

export const AddTextButton = () => {
  const dispatch = useAppDispatch();
  const disabled = useAppSelector(selectIsWidgetConfigurationSidebarOpen);

  const handleAddTextWidget = () => dispatch(addTextBox());

  return (
    <Button
      icon={<TrevorIcon name="text" />}
      variant="secondary"
      disabled={disabled}
      data-testid={DASHBOARD_ADD_TEXT_BUTTON}
      onClick={disabled ? undefined : handleAddTextWidget}
    >
      Add text
    </Button>
  );
};
